import React, { useRef, useState } from 'react';
import { Button } from 'reactstrap';
import BootstrapTable from '../../../../../../components/react-bootstrap-table-next/react-bootstrap-table2';
import { DataTableCellUploadPopup } from '../../../../../DataRequest/DataTableCellUploadPopup/DataTableCellUploadPopup';

interface TableRow {
    tableRowId: number;
}

interface VendorContractsTableProps {
    columns: string[];
    tableRows: TableRow[];
    selectedRowIds: number[];
    isReadonly: boolean;
    onChange: (selectedRowIds: number[]) => void;
    rowDisplayData?: Record<number, Record<string, string>>;
    projectId?: number | null;
    tableId?: number | null;
    fileColumnName?: string | null;
    fileColumnId?: number | null;
    isAdmin?: boolean;
}

export const VendorContractsTable = ({
    columns,
    tableRows,
    selectedRowIds,
    isReadonly,
    onChange,
    rowDisplayData,
    projectId,
    tableId,
    fileColumnName,
    fileColumnId,
    isAdmin,
}: VendorContractsTableProps) => {
    const handleToggle = (tableRowId: number, checked: boolean) => {
        if (checked) {
            onChange([...selectedRowIds, tableRowId]);
        } else {
            onChange(selectedRowIds.filter((id) => id !== tableRowId));
        }
    };
    const handleToggleRef = useRef(handleToggle);
    handleToggleRef.current = handleToggle;

    const [selectedRowTableRowId, setSelectedRowTableRowId] = useState<number | null>(null);
    const [isFilePopupVisible, setIsFilePopupVisible] = useState(false);

    const tableColumns = [
        ...columns.map((col) => {
            if (col === fileColumnName) {
                return {
                    dataField: col,
                    text: col,
                    isDummyField: true,
                    formatter: (_: unknown, row: TableRow) => (
                        <Button
                            color="primary"
                            size="sm"
                            onClick={() => {
                                setSelectedRowTableRowId(row.tableRowId);
                                setIsFilePopupVisible(true);
                            }}>
                            Files
                        </Button>
                    ),
                };
            }
            return {
                dataField: col,
                text: col,
                isDummyField: true,
                formatter: (_: unknown, row: TableRow) =>
                    rowDisplayData?.[row.tableRowId]?.[col] ?? '',
            };
        }),
        {
            dataField: 'tableRowId',
            text: 'Accept',
            headerAlign: 'center' as const,
            align: 'center' as const,
            formatExtraData: { isReadonly, selectedRowIds },
            formatter: (
                _: number,
                row: TableRow,
                _rowIndex: number,
                extra: { isReadonly: boolean; selectedRowIds: number[] }
            ) => (
                <input
                    type="checkbox"
                    checked={extra.selectedRowIds.includes(row.tableRowId)}
                    disabled={extra.isReadonly}
                    onChange={(e) =>
                        handleToggleRef.current(
                            row.tableRowId,
                            e.target.checked
                        )
                    }
                />
            ),
        },
    ];

    return (
        <div className="loi-vendor-contracts-table table-responsive">
            <BootstrapTable
                bootstrap4
                keyField="tableRowId"
                data={tableRows}
                columns={tableColumns}
                noDataIndication="No vendors available"
            />
            {isFilePopupVisible &&
                selectedRowTableRowId != null &&
                projectId &&
                tableId &&
                fileColumnId != null && (
                    <DataTableCellUploadPopup
                        projectId={projectId}
                        tableId={tableId}
                        columnId={fileColumnId}
                        rowId={selectedRowTableRowId}
                        isReadonlyMode={true}
                        isAdminView={isAdmin ?? false}
                        close={() => setIsFilePopupVisible(false)}
                        onSuccessfulUpload={() => {}}
                        title={fileColumnName || undefined}
                    />
                )}
        </div>
    );
};
